const resolveLink = ( path ) => {
    return `${path.startsWith('/') ? "" : "/"}${path.replace(/\/$|$/, `/`)}`
}

export default resolveLink